import Placeholder from '@/pages/Placeholder'

export default function DetalleIncidencia() {
  return (
    <Placeholder
      title="Detalle de Incidencia"
      description="Información de la incidencia, fotos, timeline, asignación y resolución. Próximamente."
    />
  )
}
